const axios = require("axios");

let authUser = null;

export const setUserAuth = (user) => (authUser = user);

const url = "/";
const combineURL = (endpoint) => `${url}${endpoint}`;
const makePostRequest = async (endpoint, data) => {
  const token = await authUser.getIdToken(true);
  return await axios.post(combineURL(endpoint), data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getGoogleAd = async (
  company,
  companyDescription,
  keywords,
  audience,
  headline,
  description
) => {
  return (
    await makePostRequest("googleAds", {
      Company: company,
      CompanyDescription: companyDescription,
      Keywords: keywords,
      Audience: audience,
      Headline: headline,
      Description: description,
    })
  ).data;
};

const API = {
  makePostRequest,
  getGoogleAd,
};

export default API;
